/**
 * Common Languages with Flag Emojis
 * Flag represents primary country where language is spoken
 * Sorted alphabetically by name
 */

export const LANGUAGES = [
  { code: 'ar', name: 'Arabic', flag: '\u{1F1F8}\u{1F1E6}' },      // Saudi Arabia
  { code: 'bn', name: 'Bengali', flag: '\u{1F1E7}\u{1F1E9}' },     // Bangladesh
  { code: 'zh', name: 'Chinese (Mandarin)', flag: '\u{1F1E8}\u{1F1F3}' }, // China
  { code: 'cs', name: 'Czech', flag: '\u{1F1E8}\u{1F1FF}' },       // Czech Republic
  { code: 'da', name: 'Danish', flag: '\u{1F1E9}\u{1F1F0}' },      // Denmark
  { code: 'nl', name: 'Dutch', flag: '\u{1F1F3}\u{1F1F1}' },       // Netherlands
  { code: 'en', name: 'English', flag: '\u{1F1EC}\u{1F1E7}' },     // United Kingdom
  { code: 'fi', name: 'Finnish', flag: '\u{1F1EB}\u{1F1EE}' },     // Finland
  { code: 'fr', name: 'French', flag: '\u{1F1EB}\u{1F1F7}' },      // France
  { code: 'de', name: 'German', flag: '\u{1F1E9}\u{1F1EA}' },      // Germany
  { code: 'el', name: 'Greek', flag: '\u{1F1EC}\u{1F1F7}' },       // Greece
  { code: 'he', name: 'Hebrew', flag: '\u{1F1EE}\u{1F1F1}' },      // Israel
  { code: 'hi', name: 'Hindi', flag: '\u{1F1EE}\u{1F1F3}' },       // India
  { code: 'hu', name: 'Hungarian', flag: '\u{1F1ED}\u{1F1FA}' },   // Hungary
  { code: 'id', name: 'Indonesian', flag: '\u{1F1EE}\u{1F1E9}' },  // Indonesia
  { code: 'it', name: 'Italian', flag: '\u{1F1EE}\u{1F1F9}' },     // Italy
  { code: 'ja', name: 'Japanese', flag: '\u{1F1EF}\u{1F1F5}' },    // Japan
  { code: 'ko', name: 'Korean', flag: '\u{1F1F0}\u{1F1F7}' },      // South Korea
  { code: 'ms', name: 'Malay', flag: '\u{1F1F2}\u{1F1FE}' },       // Malaysia
  { code: 'no', name: 'Norwegian', flag: '\u{1F1F3}\u{1F1F4}' },   // Norway
  { code: 'fa', name: 'Persian', flag: '\u{1F1EE}\u{1F1F7}' },     // Iran
  { code: 'pl', name: 'Polish', flag: '\u{1F1F5}\u{1F1F1}' },      // Poland
  { code: 'pt', name: 'Portuguese', flag: '\u{1F1F5}\u{1F1F9}' },  // Portugal
  { code: 'ro', name: 'Romanian', flag: '\u{1F1F7}\u{1F1F4}' },    // Romania
  { code: 'ru', name: 'Russian', flag: '\u{1F1F7}\u{1F1FA}' },     // Russia
  { code: 'es', name: 'Spanish', flag: '\u{1F1EA}\u{1F1F8}' },     // Spain
  { code: 'sv', name: 'Swedish', flag: '\u{1F1F8}\u{1F1EA}' },     // Sweden
  { code: 'tl', name: 'Tagalog', flag: '\u{1F1F5}\u{1F1ED}' },     // Philippines
  { code: 'th', name: 'Thai', flag: '\u{1F1F9}\u{1F1ED}' },        // Thailand
  { code: 'tr', name: 'Turkish', flag: '\u{1F1F9}\u{1F1F7}' },     // Turkey
  { code: 'uk', name: 'Ukrainian', flag: '\u{1F1FA}\u{1F1E6}' },   // Ukraine
  { code: 'ur', name: 'Urdu', flag: '\u{1F1F5}\u{1F1F0}' },        // Pakistan
  { code: 'vi', name: 'Vietnamese', flag: '\u{1F1FB}\u{1F1F3}' },  // Vietnam
];

export default LANGUAGES;
